import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormArray, UntypedFormControl, NgControl } from '@angular/forms';
import { filter, tap } from 'rxjs/operators';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';

@Component({
    selector: 'lib-box-shadow-editor',
    templateUrl: './box-shadow-editor.component.html',
    styleUrls: ['./box-shadow-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoxShadowEditorComponent
  extends AbstractValueAccessor
  implements OnInit
{
  array = new UntypedFormArray([]);
  updateInProgress = false;

  @Input() set preProperty(v: string) {
    if (!!v && v !== 'none' && v !== this.array.value.join(',')) {
      this.updateInProgress = true;
      v.split(',').forEach((value) => {
        this.array.push(new UntypedFormControl(value));
      });
      this.updateInProgress = false;
    }
  }

  @Output() updateProperty = new EventEmitter<string>();

  constructor(
    @Self()
    @Optional()
    private ngControl: NgControl
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  addShadow() {
    this.updateInProgress = true;
    this.array.push(new UntypedFormControl());
    this.updateInProgress = false;
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.array.valueChanges.pipe(
        filter(() => !this.updateInProgress),
        tap((v) => {
          this.updateInProgress = true;
          this.updateProperty.emit(v.join(',') || 'none');
          this.writeValue(v.join(','));
          this.updateInProgress = false;
        })
      ),
      this.valueSubject.pipe(
        filter(() => !this.updateInProgress),
        RxjsOperators.filterTruthy(),
        tap((v: string) => {
          if (!!v && v !== 'none') {
            this.updateInProgress = true;
            v.split(',').forEach((value) => {
              this.array.push(new UntypedFormControl(value));
            });
            this.updateInProgress = false;
          }
        })
      )
    );
  }
}
